<template>
    <span>
        <b-button
            @click="handleLoginAsUserClick"
            title="Login"
            variant="default"
        >
            <font-awesome-icon
                :icon="['fas', 'circle-user']"
            ></font-awesome-icon>
        </b-button>
        <modal
            :id="loginModalID"
            title="Login"
            ok-title="OK"
            @ok="handleLoginAsUser"
            @shown="onModalShown"
        >
            Are you sure you want to log in as <b>{{ this.user.email }}</b
            >?
        </modal>
    </span>
</template>

<script>
import Modal from '../../../generic/modal/modal.vue';

export default {
    components: {
        Modal,
    },
    data() {
        return {
            user: null,
            loginModalID: '',
        };
    },
    created() {
        this.user = this.params.data;
        this.loginModalID = `modal-login-as-user-${this.user.id}`;
    },
    methods: {
        onModalShown() {
            this.params.api.clearFocusedCell();
        },

        handleLoginAsUserClick() {
            this.$bvModal.show(this.loginModalID);
        },
        handleLoginAsUser() {
            window.location = `/administrative/login_as_user/${this.user.id}`;
        },
    },
};
</script>
